<template>
    
    <section id="wrapper" class="login-register">
        <div>
            <div class="login-box card">
                <div class="card-body">
                    <Form method="dialog" v-slot="{ errors }" class="form-horizontal form-material" ref="form" v-show="formShow==1">
                        <h3 class="box-title m-b-0 text-center"><img src="@/assets/images/logo.png" alt="" width="250"></h3>
                        <div class="form-group m-t-20" :class="{'has-error':errors.Email!=undefined}">
                            <Field class="form-control" name="Email" placeholder="Email" :class="{'parsley-error':errors['Email']!=undefined}" v-model="model.Email" :rules="{required:true,email:true}" @keydown.enter="entry" />
                            <ErrorMessage as="span" class="form-control-feedback small" name="Email" />
                        </div>
                        <div class="form-group m-t-20" :class="{'has-error':errors.Password!=undefined}">
                            <Field class="form-control" type="password" name="Password" placeholder="Şifre" :class="{'parsley-error':errors['Password']!=undefined}" v-model="model.Password" :rules="{required:true}" @keydown.enter="entry" />
                            <ErrorMessage as="span" class="form-control-feedback small" name="Password" />
                        </div>
                            <div class="alert alert-danger m-b-15" v-if="errs.status==4">
                                <strong>Hata!</strong> Kullanıcı bilgileriniz hatalı. Lütfen kontrol ettikten sonra tekrar deneyiniz.
                            </div>
                            <div class="alert alert-danger m-b-15" v-if="errs.status!=4 && errs.status>0">
                                <strong>Hata!</strong> 
                            </div>
                        <div class="form-group m-t-10 m-b-10">
                            <div class="d-flex no-block align-items-center">
                                <div class="ml-auto">
                                    <a href="javascript:void(0)" id="to-recover" class="text-muted" @click="formShow=2;"><i class="fa fa-lock m-r-5"></i> Şifremi Unuttum</a> 
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-center m-t-20 m-b-0">
                            <Btn class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light text-center" @click="entry" :process="process">Giriş Yap</Btn>
                        </div>
                    </Form>
                    <Form method="dialog" v-slot="{ errors }" class="form-horizontal form-material" ref="forgetPasswordForm" v-if="formShow==2">
                        <h3 class="box-title m-b-0 text-center"><img src="@/assets/images/logo.png" alt="" width="250"></h3>
                        <div class="form-group m-b-0 text-center p-t-10">
                            <div class="col-xs-12">
                                <p class="text-muted text-center">Şifrenizi unuttuysanız aşagıya müşteri kodunuzu ve e-mailinizi yazınız. </p>
                            </div>
                        </div>
                        <div class="form-group m-t-20" :class="{'has-error':errors['Telefon numaranız']!=undefined}">
                            <Field class="form-control" v-maska="'0### ### ####'" name="Telefon numaranız" placeholder="Telefon Numaranız" :class="{'parsley-error':errors['Telefon numaranız']!=undefined}" v-model="forgotPassword" :rules="{required:true,min:13}" @keydown.enter="forgetPassword" />
                            <ErrorMessage as="span" class="form-control-feedback small" name="Telefon numaranız" />
                        </div>
                        <div class="form-group m-t-10 m-b-10">
                            <div class="d-flex no-block align-items-center">
                                <div class="ml-auto">
                                    <a href="javascript:void(0)" id="to-recover" class="text-muted" @click="formShow=1;"><i class="fa fa-unlock m-r-5"></i> Giriş Yap</a> 
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-center m-t-20 m-b-0">
                            <Btn class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light text-center" @click="forgetPassword" :process="forgetPasswordProcess">Login</Btn>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    // import VueResource from 'vue-resource';
    // extend('even', value => {
    //     return value % 2 === 0;
    // });

    export default {
        name:"login",
        data(){
            return {
                formShow:1,
                model:{
                    Email:"",
                    Password:""
                },
                errs:{

                },
                process:false,
                forgotPassword:null,
                forgetPasswordProcess:false
            }
        },
        created(){
            // service.isLogin();
            console.log(this.$appAxiosAdmin.defaults);
        },
        methods: {
            entry(){
                this.$refs.form.validate().then(valid =>{
                    if(valid.valid){
                        this.process=true;
                        return this.$appAxiosOther
                            .post(`https://api.kolayrez.com/auth/login`, this.model)
                            .then((r) => {
                                this.process=false;
                                let response={ReturnObject:r.data};
                                if(response.ResultType>0){
                                    this.errs={status:response.ResultType};
                                    return false;
                                }
                                console.log("Login",response.ReturnObject);
                                this.$store.commit("setUser", response.ReturnObject);
                                this.$appAxios.defaults.headers.Authorization=response.ReturnObject.Token;
                                this.$appAxiosAdmin.defaults.headers.Authorization=response.ReturnObject.Token;
                                this.$appAxiosTourscope.defaults.headers.Authorization=response.ReturnObject.Token;
                                this.$appAxiosKolayrez.defaults.headers.Authorization=response.ReturnObject.Token;
                                this.$router.push({ name: "Home" });
                            });
                    }
                }).catch(()=>{
                    this.process=false;
                    this.$swal({
                        icon:"error",
                        title:"Hata",
                        text:"Giriş işlemi sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.",
                        timer: 2000,
                        confirmButtonText:"Okey"
                    });
                });
            },
            forgetPassword(){
                this.$refs.forgetPasswordForm.validate().then(valid =>{
                    if(valid.valid){
                        this.forgetPasswordProcess=true;
                        this.$appAxios.get(`ForgetPassword/`+this.forgotPassword.replaceAll(' ','').slice(1,13)).then(response => {
                            this.formShow=1;
                            this.forgetPasswordProcess=false;
                            this.forgotPassword="";
                            this.$swal({
                                icon:"success",
                                title:"Başarılı",
                                text:response.data,
                                timer: 2000,
                                confirmButtonText:"Okey"
                            });
                        }).catch(()=>{
                            this.$swal({
                                icon:"error",
                                title:"Hata",
                                text:"Şifreniz gönderilemedi.",
                                timer: 2000,
                                confirmButtonText:"Okey"
                            });
                            this.forgetPasswordProcess=false;
                        });
                    }
                });
            }
        }
    }
</script>
<style scoped>
    .form-group input{
        border:1px solid #d9d9d9 !important;
        border-bottom: 0;
        padding: 6px 10px;
        height:50px;
    }
    .has-error input{
        border-color:#fc4b6c !important;
    }
    .form-control-feedback{
        color:#fc4b6c;
    }
</style>
